import { Flex } from '@teamsparta/stack-flex';
import Link from 'next/link';

import * as S from './style';

export function EventInvitation() {
  return (
    <S.Wrapper>
      <Flex.Column
        justify='center'
        align='center'
        gap='32px'
        style={{ maxWidth: '600px', padding: '80px 16px' }}
      >
        <Flex.Column justify='center' align='center' gap='16px'>
          <S.Title>
            {'항해99는 한국 최대\n개발자 커뮤니티로 성장 중입니다.'}
          </S.Title>
          <S.Description>
            {'마케팅 수신에 동의하고,\n개발자 행사에 가장 먼저 초대 받으세요!'}
          </S.Description>
        </Flex.Column>
        <Flex
          justify='center'
          align='center'
          gap='4px'
          style={{ width: '300px', minWidth: '100px', padding: '13px 16px' }}
        >
          <div>
            <Link
              href='https://online.spartaclub.kr/mypage/mybasicinfo?scrollTo=marketing'
              target='_blank'
              style={{
                width: '100%',
              }}
            >
              <S.Button>행사 소식 받기</S.Button>
            </Link>
          </div>
        </Flex>
      </Flex.Column>
    </S.Wrapper>
  );
}
